import { render } from "./ReportQuestionModal.vue?vue&type=template&id=08f1c166&scoped=true"
import script from "./ReportQuestionModal.vue?vue&type=script&lang=js"
export * from "./ReportQuestionModal.vue?vue&type=script&lang=js"

import "./ReportQuestionModal.vue?vue&type=style&index=0&id=08f1c166&lang=scss&scoped=true"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f1c166"]])

export default __exports__